var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { debounce } from 'lodash-es';
import { Icon } from '../../Atoms/Icon';
import { DefaultTheme } from '../../Themes';
const StyledContainer = styled.div `
  display: flex;
  align-items: center;
  padding: 0 0.833333333rem;
  background-color: #fff;
  border: 2px solid #d7dae0;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;

  &:focus-within {
    border-color: ${({ theme }) => theme.ThemeColors.PRIMARY.hex};
  }
`;
const StyledInput = styled.input `
  flex: 1;
  border: 0;
  font: inherit;
  color: inherit;
  background-color: transparent;

  &:focus {
    outline: 0;
  }
`;
const StyledIcon = styled(Icon) `
  margin-right: 0.833333333rem;
`;
const TextInput = (_a) => {
    var { className, inputClassName, iconClassName, icon, id, isDisabled, name, onChange = () => { }, placeholder, theme = DefaultTheme, value = '', delay = 0 } = _a, rest = __rest(_a, ["className", "inputClassName", "iconClassName", "icon", "id", "isDisabled", "name", "onChange", "placeholder", "theme", "value", "delay"]);
    const [currentValue, setCurrentValue] = useState('');
    useEffect(() => () => {
        delayedOnChange.cancel();
    }, []);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    const delayedOnChange = useCallback(debounce(onChange, delay), [delay, onChange]);
    const handleChange = useCallback((event) => {
        event.persist();
        setCurrentValue(event.target.value);
        delayedOnChange(event);
    }, [delayedOnChange]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledContainer, { className: className },
            icon && React.createElement(StyledIcon, { className: iconClassName, icon: icon }),
            React.createElement(StyledInput, Object.assign({ className: inputClassName, disabled: isDisabled, id: id, name: name, onChange: handleChange, placeholder: placeholder, type: 'text', value: currentValue }, rest)))));
};
export default TextInput;
